<template>
  <main
    class="flex min-h-dvh flex-col font-merriweather leading-7 dark:bg-gray-700 dark:text-neutral-200"
  >
    <AppHeader :scroll-y="scrollY" @update:height="headerHeight = $event" />

    <div
      :class="
        !isDocument
          ? 'mx-auto mt-24 w-full max-w-3xl px-4 pb-8 sm:mt-32'
          : undefined
      "
    >
      <AppFlash v-if="flash" :flash="flash" />

      <RouterView v-slot="{ Component }" class="min-w-0">
        <KeepAlive include="Works" max="1">
          <component
            :is="Component"
            :key="$route.path"
            :header-height="headerHeight"
            :is-authorized="isAuthorized"
            @scroll="scrollY = $event"
          />
        </KeepAlive>
      </RouterView>

      <div class="flex flex-col items-center p-4 sm:items-end">
        <AuthView
          :is-authorized="isAuthorized"
          @set:authorized="isAuthorized = $event"
        />
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
  import { RouterView } from 'vue-router'
  import { useHead } from '@unhead/vue'
  import { useRoute } from 'vue-router'
  import { computed, provide, ref } from 'vue'

  import AppHeader from './components/AppHeader.vue'
  import AuthView from './components/AuthView.vue'
  import AppFlash from './components/AppFlash.vue'
  import { flashKey } from './injectionKeys'

  const isAuthorized = ref(false)
  const baseTitle = 'Oepke Noordmans'
  const route = useRoute()
  const scrollY = ref(window.scrollY)
  const headerHeight = ref(0)

  const flash = ref<NMFlash | null>(null)

  const setFlash = (newFlash: NMFlash) => (flash.value = newFlash)
  provide(flashKey, setFlash)

  const isDocument = computed(() =>
    ['publication', 'document'].includes(route.name as string),
  )

  useHead({
    title: null,
    titleTemplate: (title) => {
      if (title) {
        return `${title} — ${baseTitle}`
      } else {
        return baseTitle
      }
    },
  })

  window.addEventListener('scroll', () => (scrollY.value = window.scrollY))
</script>
